import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('selectGlobalListViewTypeOption')(function selectGlobalListViewTypeOption(selection, state) {
    var optionState = state.optionState;
    optionState.globalListViewType = selection;
}));
//# sourceMappingURL=selectGlobalListViewTypeOption.js.map